import * as config from "../config/i18n";

const translationLoader = {
  type: "backend",
  init: () => { },
  read: function (language, namespace, callback) {
    let resource,
      error = null;

    try {
      let language = "";
      const windowlanguage = window.navigator.languages
        ? window.navigator.languages[0]
        : "en";
        
      if (["ja", "en"].indexOf(windowlanguage) >= 0) {
        language = windowlanguage;
      } else {
        language = "en";
      }


      // 	useEffect(() => {
      // 		// i18n.changeLanguage(lang);
      // 		i18next.changeLanguage(language[0]);
      // 	}, [lang, i18next]);

      resource = config.supportedLocales[language] // .supportedLocales[language]
        // .supportedLocales["ja"]
        // .translationFileLoader()[namespace];
        .translationFileLoader();
    } catch (_error) {
      error = _error;
    }

    callback(error, resource);
  },
};

export default translationLoader;
